import { MaintenanceWindowFormPatchSpecificsController } from '../controller/MaintenanceWindowFormPatchSpecificsController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { MaintenanceWindowSchedulerWebComponent } from '../../../maintenanceWindows/maintenanceWindowScheduler';
import { MaintenanceWindowSimpleSchedulerWebComponent } from '../../../maintenanceWindows/maintenanceWindowSimpleScheduler';
import { MaintenanceWindowPatchSpecificsFormData, Schedulers } from '../types';

export class MaintenanceWindowFormPatchSpecificsWebComponent extends BaseWebComponentElement {
  public controller: MaintenanceWindowFormPatchSpecificsController | null;
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MaintenanceWindowFormPatchSpecificsController,
    });
  }

  public getScheduler(
    type: Schedulers,
    isFallback = false
  ): MaintenanceWindowSchedulerWebComponent | MaintenanceWindowSimpleSchedulerWebComponent | undefined {
    return this.controller?.view.getScheduler(type, isFallback);
  }

  public getVendorProductsPairs() {
    return this.controller?.view.dom.additionalPatchSettings.$vendorProductSelector.vendorProductsPairs;
  }

  public isVendorProductPairsEnabled() {
    return !this.controller?.view.dom.additionalPatchSettings.$vendorProductSelector.disabled;
  }

  public getCachingServers() {
    return this.controller?.view.dom.additionalPatchSettings.$relayPatchCachingServers.cachingServers;
  }

  public isCachingServersEnabled() {
    return !this.controller?.view.dom.additionalPatchSettings.$relayPatchCachingServers.disabled;
  }

  public getManuallyApprovedPatchIds(): string[] {
    return this.controller?.view.dom.$manuallyApprovedPatchesSelector.selectedPatchIds;
  }

  get disabled(): boolean {
    const attributeValue = this.getAttribute('disabled');
    return attributeValue !== null;
  }

  set disabled(value: boolean) {
    if (value) {
      this.setAttribute('disabled', 'true');
    } else {
      this.removeAttribute('disabled');
    }
    this.controller?.view.setDisabledInnerComponents(value);
  }

  get viewData(): MaintenanceWindowPatchSpecificsFormData | any {
    const attributeValue = this.getAttribute('data-view-data');
    return attributeValue ? JSON.parse(attributeValue) : undefined;
  }

  set viewData(value: MaintenanceWindowPatchSpecificsFormData) {
    if (typeof value !== 'undefined') {
      this.setAttribute('data-view-data', JSON.stringify(value));
    } else {
      this.removeAttribute('data-view-data');
    }
    this.controller?.render();
  }

  public async resetViewData() {
    this.removeAttribute('data-view-data');
    await this.controller?.render();
  }

  get checkboxesComputationState(): string {
    const attributeValue = this.getAttribute('data-checkboxesComputationState');
    return attributeValue !== null ? attributeValue : String(16);
  }

  set checkboxesComputationState(value: string) {
    this.setAttribute('data-checkboxesComputationState', value);
    this.controller?.onCheckboxesComputationState(value);
    if (this.disabled) {
      this.controller?.view.setDisabledInnerComponents(true);
    }
  }
}
